'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './schedule.routes';
import {ModalBase} from '../shared/modal.base';
import { ISeason, IPickupOption, IPickupUserEvent, IPickupEvent, IExtraEvent, IBasket, IOptionsService, IPickupUtilsService, IPickupOptionsService } from '../interfaces';

export class ScheduleComponent extends ModalBase{
  $http: ng.IHttpService;
  PickupOptionsService: IPickupOptionsService;
  ExtrasService: any;
  $state: ng.ui.IStateService;

  userId: string;
  pickupOptions: IPickupOption[];
  userEvents = [];
  season: ISeason;
  PickupUtils: IPickupUtilsService;
  loading: Boolean = true;
  baskets: IBasket[];
  $timeout: any;
  OptionsService: IOptionsService;
  TranslationService;
  
  activeSeason: any = null;
  openRegistrationsSeason: any = null;

  alertNoActiveNoRegistrations: boolean = false;
  alertActiveNoBaskets: boolean = false;
  alertRegistrationsNoBaskets: boolean = false;
  alertRegistrationsNoPayments: boolean = false;
  alertMessage = '';

  /*@ngInject*/
  constructor($http, Auth, $timeout, $uibModal, PickupOptionsService, PickupUtils, $state, OptionsService, ExtrasService, TranslationService) {
    super($uibModal);
    this.$timeout = $timeout;
    this.$http = $http;
    this.$uibModal = $uibModal;
    this.PickupOptionsService = PickupOptionsService;
    this.PickupUtils = PickupUtils;
    this.$state = $state;
    this.OptionsService = OptionsService;
    this.ExtrasService = ExtrasService;
    this.TranslationService = TranslationService;
    Auth.getCurrentUser()
      .then(user => this.userId = user._id);
  }

  $onInit() {
    let scope = this;
    this.PickupOptionsService.get()
    .then(pickupOptions => { 
      this.pickupOptions = pickupOptions
      this.reload();
    });
  }

  reload() {
    let scope = this;
    
    //Schedule for member
    this.$http.get('/api/memberships/schedule')
    .then(res => {
      let data = (res.data as any);
      scope.processBaskets(data.baskets as IBasket[]);
      if (scope.baskets.length>0) {
        scope.processUserEvents(data.pickupUserEvents as IPickupUserEvent[]);
        scope.processExtraEvents(data.extraEvents as IExtraEvent[]);
      }

      this.sortUserEvents();
      scope.loading = false;

      //Registrations for season and alerts
      this.alertNoActiveNoRegistrations = false;
      this.alertActiveNoBaskets = false;
      this.alertRegistrationsNoBaskets = false;
      this.alertRegistrationsNoPayments = false;

      this.OptionsService.getActiveSeason()
      .then(activeSeason => {
        scope.activeSeason = activeSeason;

        scope.OptionsService.getOpenRegistrationsSeason()
        .then(openRegistration => {

          scope.openRegistrationsSeason = openRegistration;
          
          // TODO: Check the case when no baskets, no registrations and active season
          // if (scope.openRegistrationsSeason === '' && scope.baskets.length === 0) {
          //   scope.alertNoActiveNoRegistrations = true;
          //   return;
          // }
          
          this.$http.get('/api/memberships/member')
          .then(res => {
            let membership = res.data as any;

          //   if (scope.activeSeason._id !== '' && scope.openRegistrationsSeason._id === '') {
          //     scope.alertActiveNoBaskets = !membership.baskets.some(b => {
          //       return b.season._id === scope.openRegistrationsSeason._id
          //     });

          //     if (scope.alertRegistrationsNoBaskets) return;

          //     scope.alertRegistrationsNoPayments = membership.baskets.some(b => {
          //       return b.payments.every(p => p.amount==0)
          //     });
          //   }

            if (scope.openRegistrationsSeason) {
              scope.alertRegistrationsNoBaskets = !membership.baskets.some(b => {
                return b.season._id === scope.openRegistrationsSeason._id
              });
            }

          //     if (scope.alertRegistrationsNoBaskets) return;

          //     scope.alertRegistrationsNoPayments = membership.baskets.some(b => {
          //       return b.payments.every(p => p.amount==0)
          //     });
          //     return;
          //   }

          //   if (scope.activeSeason._id !== '' && scope.openRegistrationsSeason._id !== '') {
          //     if (scope.activeSeason._id === scope.openRegistrationsSeason._id) {
          //       scope.alertActiveNoBaskets = scope.baskets.some(b => {
          //         return b.season._id === scope.openRegistrationsSeason._id
          //       });
          //     }
              

          //     if (scope.alertRegistrationsNoBaskets) return;

          //     scope.alertRegistrationsNoPayments = membership.baskets.some(b => {
          //       return b.payments.every(p => p.amount==0)
          //     });
          //   }

          //   if (scope.activeSeason._id === scope.openRegistrationsSeason._id) {
          //     scope.alertActiveNoBaskets = membership.baskets.some(b => {
          //       return b.season._id === scope.activeSeason._id && !b.enable
          //     });
          //   }
            
          });

        });
        
      });
    });

  }

  getPickupOption(pickupOptionId) {
    return _.find(this.pickupOptions, option => {
      return option._id+'' === pickupOptionId+'';
    });
  }

  processBaskets(baskets: IBasket[]) {
    if (baskets.length>0) {
      this.season = _.first(baskets).season;
      this.baskets = baskets;
    } else {
      this.season = null;
      this.baskets = [];
    }
  }

  processUserEvents(loadedUserEvents) {
    let scope = this;
    scope.userEvents = [];
    _.each(loadedUserEvents, userEvent => {
      let processedEvent = scope.processUserEvent(userEvent);
      scope.userEvents.push(processedEvent);
    });
  }

  processExtraEvents(extraEvents) {
    _.each(extraEvents, extraEvent => {
      let startDate = new Date(extraEvent.date);
      let endDate = new Date(startDate.getTime()+extraEvent.durationMinutes*60*1000);
      this.userEvents.push({
        userEvent: null,
        title: extraEvent.title,
        description: extraEvent.description,
        location: extraEvent.location,
        startDate: startDate,
        endDate: endDate
      });
    })
  }

  sortUserEvents() {
    let now = new Date().getTime();
    this.userEvents = _.sortBy(this.userEvents, candidate => {
      if (now > candidate.startDate.getTime()) {
        /// Add to the end of the list
        return candidate.startDate.getTime()+365*24*60*60*1000;
      } else {
        return candidate.startDate.getTime();
      }
    });
  }

  processUserEvent(userEvent) {
    let scope = this;
    let actualEvent = userEvent.pickupEventOverride || userEvent.pickupEvent;
    let actualPickupOptionId = actualEvent.pickupOptionOverride || actualEvent.pickupOption;
    if (_.has(actualPickupOptionId, '_id')) {
      actualPickupOptionId = actualPickupOptionId._id;
    }
    let actualPickupOption = scope.getPickupOption(actualPickupOptionId);
    let actualPickupOptionForDateId = actualEvent.pickupOption;
    if (_.has(actualPickupOptionForDateId, '_id')) {
      actualPickupOptionForDateId = actualPickupOptionForDateId._id;
    }
    let actualPickupOptionForDate = scope.getPickupOption(actualPickupOptionForDateId);
    let eventExtraIds = actualEvent.availableExtras;
    let basketExtras = userEvent.basket.extras;
    let availableExtras = [];
    
    if (basketExtras.length>0 && eventExtraIds.length>0) {
      for (let eventExtraId of eventExtraIds) {
        let match = _.find(basketExtras, candidate => {
          return (candidate as any).extra == eventExtraId;
        });
        if (match) {
          let seasonExtra = _.find(this.season.availableExtras, (extra) => {
            return extra._id == eventExtraId;
          });
          seasonExtra = this.ExtrasService.getExtraBases(seasonExtra);
          availableExtras.push({
            "name": seasonExtra.name,
            "unit": seasonExtra.unit,
            "quantity": (match as any).quantity
          });
        }
      }
    }

    // Get the current pickup contact
    let pickupContact = this.getPickupContact(userEvent);

    return {
      userEvent: userEvent,
      actualEvent: actualEvent,
      isPickupOverride: userEvent.pickupEventOverride!=null,
      eventNumber: userEvent.pickupEvent.eventNumber,
      startDate: scope.PickupUtils.getStartDateFor(this.season, actualPickupOptionForDate, actualEvent),
      endDate: scope.PickupUtils.getEndDateFor(this.season, actualPickupOptionForDate, actualEvent),
      // userNote: userEvent.userNote,
      adminNote: actualEvent.adminNote,
      // delegate: userEvent.delegate,
      // absent: userEvent.absent,
      editable: userEvent.editable,
      old: userEvent.old,
      done: userEvent.done,
      pickupOption: actualPickupOption,
      availableExtras: availableExtras,
      pickupContact: pickupContact,
    };
  }

  getPickupContact(userEvent) {
    return userEvent.pickupEvent.pickupContact
      ? userEvent.pickupEvent.pickupContact
      : userEvent.pickupEvent.pickupOption.defaultContact;
  }

  getOptionResolve() {
    let scope = this;
    return {
      season: function () {
        return scope.season;
      },
      baskets: function () {
        return scope.baskets;
      },
    };
  }

  getResolve(userEvent = null) {
    let scope = this;
    return {
      season: function () {
        return scope.season;
      },
      userEvent: function () {
        return userEvent;
      }
    };
  }

  edit(userEvent) {
    let scope = this;
    this.modal('userPickupEdit', this.getResolve(userEvent), editedUserEvent => {
      let newProcessedEvent = scope.processUserEvent(editedUserEvent);
      let oldProcessedEvent = _.find(scope.userEvents, candidateEvent => {
        return candidateEvent.userEvent._id+'' === userEvent._id+'';
      });
      
      // Keep the same pickup contact because it cannot be modified in this pickup update
      newProcessedEvent.pickupContact = this.getPickupContact(userEvent);

      if (oldProcessedEvent && newProcessedEvent) {
        // Update the help out in pickip event
        if (oldProcessedEvent.actualEvent._id !== newProcessedEvent.actualEvent._id 
          && oldProcessedEvent.actualEvent.helpOut == scope.userId) {
            scope.removeHelpOut(oldProcessedEvent.actualEvent);
        }

        // Update the old user event
        _.assign(oldProcessedEvent, newProcessedEvent);
        scope.sortUserEvents();
      }
    });
  }

  // reset(item) {
  //   let scope = this;
  //   let patches = {
  //     delegate: null,
  //     userNote: null,
  //     absent: false,
  //     pickupEventOverride: null,
  //   };
  //   // Call the api to override the pickup event
  //   this.$http.patch('/api/pickupUserEvents/user/'+ item.userEvent._id, patches)
  //   .then((result) => {
  //     let data = (result.data as any);
  //     item.userEvent.pickupEvent = data.pickupEvent;
  //     item.userEvent.delegate = data.delegate;
  //     item.userEvent.userNote = data.userNote;
  //     item.userEvent.absent = data.absent;
  //     item.userEvent.pickupEventOverride = data.pickupEventOverride;
  //     item.pickupOption = data.pickupEvent.pickupOption;
  //     item.isPickupOverride = false;
  //   })
  // }

  goToMembership() {
    this.$state.go('membership');
  }

  /**
   * Add helping out for a pickup event
   */
  addHelpOut(actualEvent) {
    let scope = this;
    if (!actualEvent.helpOut) {
      this.modal('helpOut', this.getResolve(), res => {
        if (res) {
          this.$http.patch('/api/pickupEvents/addHelpout/'+ actualEvent._id, {helpOut: this.userId})
          .then(res => {
            if (res.status == 200) {
              actualEvent.helpOut = this.userId;
            }
          });
        }
        // userEvent.actualEvent.helpOut = this.userId;
      });
    }
  }

  /**
   * Cancel helping out
   */
  removeHelpOut(actualEvent) {
    let scope = this;

    // Call API to remove  help out
    if (actualEvent.helpOut) {
      this.$http.patch('/api/pickupEvents/removeHelpout/'+ actualEvent._id, {userHelpOutId: this.userId})
      .then(res => {
        if (res.status == 200) {
          actualEvent.helpOut = null;
        }
      });
    }
  }

}

export default angular.module('terrappApp.schedule', [uiRouter])
  .config(routes)
  .component('schedule', {
    template: require('./schedule.html'),
    controller: ScheduleComponent,
    controllerAs: '$ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/schedule/schedule.component.ts